import { useCallback, useEffect } from 'react';

import { useLocation } from 'react-router-dom';

import {
  measureApiCall,
  measureChallengeLoad,
  measureDataFetch,
  measurePageLoad,
  measureTradeExecution,
  measureUserAction,
} from '@/lib/performance';

export const usePagePerformance = () => {
  const location = useLocation();

  useEffect(() => {
    if (!import.meta.env.DEV) {
      const stopTrace = measurePageLoad(
        location.pathname.replace('/', '') || 'home'
      );
      return stopTrace;
    }
  }, [location]);
};

export const useApiPerformance = () => {
  const measureApi = useCallback((endpoint: string) => {
    if (!import.meta.env.DEV) {
      return measureApiCall(endpoint);
    }
    return () => {};
  }, []);

  return { measureApi };
};

export const useUserActionPerformance = () => {
  const measureAction = useCallback((actionName: string) => {
    if (!import.meta.env.DEV) {
      return measureUserAction(actionName);
    }
    return () => {};
  }, []);

  return { measureAction };
};

export const useChallengePerformance = () => {
  const measureChallenge = useCallback((challengeId: string) => {
    if (!import.meta.env.DEV) {
      return measureChallengeLoad(challengeId);
    }
    return () => {};
  }, []);

  return { measureChallenge };
};

export const useTradePerformance = () => {
  const measureTrade = useCallback((coinId: string) => {
    if (!import.meta.env.DEV) {
      return measureTradeExecution(coinId);
    }
    return () => {};
  }, []);

  return { measureTrade };
};

export const useDataFetchPerformance = () => {
  const measureFetch = useCallback((dataType: string) => {
    if (!import.meta.env.DEV) {
      return measureDataFetch(dataType);
    }
    return () => {};
  }, []);

  return { measureFetch };
};
